import { useGetUserQuestionsForAdminQuery } from "../userQuestionApiSlice"

import UserQuestionAdmin from "./UserQuestionAdmin"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useParams } from "react-router-dom"
const UserQuestionListAdmin = ({ q, finalQuestionId}) => {
    const {groupId} = useParams()
    const {
        data: userQuestions,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserQuestionsForAdminQuery({groupId}, {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    if (isSuccess ) {
       
        let filtered = []
        if(q!=='' || finalQuestionId!==''){
             filtered=userQuestions.filter(uq=>{
                    return ((q==="" ||  ((uq.fullname.indexOf(q) > -1) ||(uq.username.indexOf(q) > -1) ) )
                     &&(finalQuestionId==="" || uq.finalQuestionSet._id===finalQuestionId))
             })

            }
            else{
                filtered = [...userQuestions]
            } 

        

        const tableContent =  filtered.map(userQuestion => <UserQuestionAdmin key={userQuestion._id} userQuestion={userQuestion} />)

        content = (
            <>
            <table className={`table table--userQuestions  `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th userQuestion__title">שאלון</th>
                        <th scope="col" className="table__th userQuestion__body">משתמש</th>
                        <th scope="col" className="table__th userQuestion__dates"> שם </th>
                        <th scope="col" className="table__th userQuestion__actions"> מתאריך</th>
                        <th scope="col" className="table__th userQuestion__actions"> עד תאריך</th>
                        <th scope="col" className="table__th userQuestion__actions"> ציון</th>
                        <th scope="col" className="table__th userQuestion__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default UserQuestionListAdmin